export const numbersAndLettersOnly = /^[A-Za-z0-9]*$/;
export const numbersAndLettersAndDotOnly = /^[A-Za-z0-9.]*$/;
export const numbersOnly = /^\d+$/;
export const numbersLettersAtoFhyphensOnly = /^[0-9A-F-]+$/;
